import { parseHTMLToOoxmlCursively } from './HTML';
import { convertToOOXML, blankParagraph } from "./OOXML";
import { px2OOXML } from './Helper';
import { rgbaToHex } from "../Color";

export function parseTDToOOXML(ctx, parentOOXML, ooxmlChildren, node) {
    let children = [];
    Array.from(node.childNodes).forEach((cn) => {  
        parseHTMLToOoxmlCursively(ctx, cn, parentOOXML).forEach(pr => {
            if (pr._tag === "w:r") children.push(pr);
            else {
                if (children?.length) {
                    ooxmlChildren.push(convertToOOXML({
                        tag: "w:p",
                        children: [],
                        ooxmlChildren: children
                    }));
                    children = [];
                } 
                ooxmlChildren.push(pr);
            }
        });
    });
    if (children?.length) {
        ooxmlChildren.push(convertToOOXML({
            tag: "w:p",
            children: [],
            ooxmlChildren: children
        }));
    } else ooxmlChildren.push(convertToOOXML(blankParagraph()));
    const computedStyle = window.getComputedStyle(node);
    const cellMargins = [];
    const cellBorders = [];

    ["top", "left", "bottom", "right"].forEach((side) => {
        const padding = Math.round(px2OOXML(computedStyle.getPropertyValue(`padding-${side}`)));
        if (!isNaN(padding)) {
            cellMargins.push({ tag: `w:${side}`, attrs: { "w:w": `${padding}`, "w:type": "dxa"} });
        }
        const borderSize = Math.round(px2OOXML(computedStyle.getPropertyValue(`border-${side}-width`)));
        const borderColor = computedStyle.getPropertyValue(`border-${side}-color`);
        const borderStyle = computedStyle.getPropertyValue(`border-${side}-style`);
        
        const borderAttrs = {};
        if (!isNaN(borderSize)) {
            borderAttrs["w:sz"] = `${borderSize}`; 
        } else if (borderStyle === "inset") {
            borderAttrs["w:sz"] = `${Math.round(borderSize / 2)}`;
        }
        if (borderColor && borderColor !== "rgba(0, 0, 0, 0)") {
            borderAttrs["w:color"] = rgbaToHex(borderColor);
        }
        if (isNaN(borderSize) || !borderSize || !borderColor || borderColor === "rgba(0, 0, 0, 0)") {
            borderAttrs["w:val"] = "none";
        } else if (borderStyle) {
            borderAttrs["w:val"] = ({
                "none":	"none",
                "hidden": "none",
                "dotted": "dotted",
                "dashed": "dashed",
                "solid": "single",
                "double": "double",
                "groove": "threeDEngrave",
                "ridge": "threeDEmboss",
                "inset": "inset",
                "outset": "outset",
            })[borderStyle];
        }
        if (Object.keys(borderAttrs).length) {
            borderAttrs["w:space"] = "0";
            cellBorders.push({ tag: `w:${side}`, attrs: borderAttrs });
        }
    });
    
    const cellProps = [{ tag: "w:tcW", attrs: { "w:w": "0", "w:type": "auto" }}];
    if (node.rowSpan && node.rowSpan > 1) {
        cellProps.push({ tag: "w:vMerge", attrs: { "w:val": "restart" } });
    }
    
    if (node.colSpan && node.colSpan > 1) {
        cellProps.push({ tag: "w:gridSpan", attrs: { "w:val": `${node.colSpan}` } });
    }
    cellProps.push({ tag: "w:tcBorders", children: cellBorders});
    
    const backgroundColor = computedStyle.getPropertyValue("background-color");
    if (backgroundColor && backgroundColor !== "rgba(0, 0, 0, 0)") {
        cellProps.push({ tag: "w:shd", attrs: { "w:val":"clear", "w:color": "auto", "w:fill": rgbaToHex(backgroundColor) || "#ffffff00" } });
    }
    cellProps.push({ tag: "w:tcMar", children: cellMargins});

    const valign = node.getAttribute("valign") || "center";    
    cellProps.push({ tag: "w:vAlign", attrs: { "w:val": valign } });
    
    ctx.lastCellProps = [...cellProps];
    return [convertToOOXML({
        tag: "w:tc",
        ooxmlChildren,
        children: [{tag: "w:tcPr", children: cellProps}]
    }, parentOOXML)];
}